export const NOTA_COMERCIAL_MODULE_NAME = "nota_comercial_module";

export const notaComercialModuleMenuItem = {
  icon: "file-invoice",
  path: "/nota-comercial/simulador",
};

export const notaComercialModuleRoutes = [
  {
    path: "nota-comercial/simulador",
    name: "NotaComercialSimulator",
    component: () => import("./pages/NotaComercialSimulator.vue"),
    meta: {
      title: "Notas comerciales",
      requiresAuth: true,
      requiresModule: NOTA_COMERCIAL_MODULE_NAME,
    },
  },
];

export default {
  moduleName: NOTA_COMERCIAL_MODULE_NAME,
  routes: notaComercialModuleRoutes,
  menuItem: notaComercialModuleMenuItem,
};
